import type { CountryConfig } from './types';

/**
 * DEPRECATED (2026-10-02): the MX operation stopped using the app after the
 * owner split with his MX associate — treat MX as non-functional. Don't add or
 * test new features here; see CLAUDE.md → Multi-country scoping.
 *
 * Mexico — placeholder. Phase 1 only needs the country to exist so the
 * switcher and active-country header work. Tax engine, CFDI catalog,
 * Nova-bank threshold rule, and MX-specific payment methods are filled
 * in during Phase 3 (MX rollout).
 */
export const mxCountry: CountryConfig = {
  code: 'MX',
  name: 'México',
  flag: '🇲🇽',
  currency: { primary: 'MXN' },
  features: new Set(['cfdi', 'nova_threshold']),
  ivaRates: [16, 8],
  ivaRateDefault: 16,
};
